import React, { useState, useContext } from "react";
import {
  Stack,
  MenuList,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Popover,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  MoreVert as MoreVertIcon,
  Autorenew as AutorenewIcon,
} from "@mui/icons-material";
import { useMutation } from "@apollo/client";

// Project Imports
import { AuthContext } from "../../../../../Context/AuthContext";
import { DELETE_CLASS } from "../../../../../Schema/Class";
import DialogDelete from "../../../../../Utils/DialogDelete";
import AssignClassToStudentForm from "../AssignClassToStudentForm";
import Status from "./Status";

export default function ClassAction({ editData, setRefetch }) {
  const { t, setAlert } = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [openDel, setOpenDel] = useState(false);
  const [loading, setLoading] = useState(false);

  const isOpen = Boolean(anchorEl);
  const id = isOpen ? "class-action-popover" : undefined;

  const handlePopoverOpen = (e) => setAnchorEl(e.currentTarget);
  const handlePopoverClose = () => setAnchorEl(null);

  const handleDialog = (type, value) => {
    if (type === "edit") setOpenEdit(value);
    else if (type === "status") setOpenStatus(value);
    else if (type === "delete") setOpenDel(value);
  };

  const [deleteClass] = useMutation(DELETE_CLASS, {
    onCompleted: ({ deleteClass }) => {
      setLoading(false);
      if (deleteClass?.isSuccess) {
        setAlert(true, "success", deleteClass.message);
        setRefetch();
        handleDialog("delete", false);
      } else {
        setAlert(true, "error", deleteClass.message);
      }
    },
    onError: (error) => {
      console.error("Delete error:", error.message);
      setLoading(false);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteClass({ variables: { id: editData?._id } });
  };

  return (
    <>
      {/* More Button */}
      <IconButton onClick={handlePopoverOpen}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{
            bgcolor: "white !important",
            width: 24,
            height: 24,
            padding: 1,
            borderRadius: 1,
          }}
        >
          <MoreVertIcon fontSize="small" sx={{ color: "#131870" }} />
        </Stack>
      </IconButton>

      {/* Popover Menu */}
      <Popover
        id={id}
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuList>
          <MenuItem
            onClick={() => {
              handleDialog("status", true);
              handlePopoverClose();
            }}
          >
            <ListItemIcon>
              <AutorenewIcon fontSize="small" sx={{ color: "orange" }} />
            </ListItemIcon>
            <ListItemText>{t("status")}</ListItemText>
          </MenuItem>

          <MenuItem
            onClick={() => {
              handleDialog("edit", true);
              handlePopoverClose();
            }}
          >
            <ListItemIcon>
              <EditIcon fontSize="small" sx={{ color: "#131870" }} />
            </ListItemIcon>
            <ListItemText>{t("update")}</ListItemText>
          </MenuItem>

          <MenuItem
            onClick={() => {
              handleDialog("delete", true);
              handlePopoverClose();
            }}
          >
            <ListItemIcon>
              <DeleteIcon fontSize="small" sx={{ color: "red" }} />
            </ListItemIcon>
            <ListItemText>{t("delete")}</ListItemText>
          </MenuItem>
        </MenuList>
      </Popover>

      {/* Edit Modal */}
      {openEdit && (
        <AssignClassToStudentForm
          open={openEdit}
          dialogTitle={"Update"}
          // studentId={editData?.studentId?._id}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={() => handleDialog("edit", false)}
        />
      )}

      {/* Status Modal */}
      {openStatus && (
        <Status
          open={openStatus}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={() => handleDialog("status", false)}
        />
      )}

      {/* Delete Confirmation Modal */}
      {openDel && (
        <DialogDelete
          open={openDel}
          loading={loading}
          handleClose={() => handleDialog("delete", false)}
          deleteTitle={t("modal_title_delete_class")}
          handleDelete={handleDelete}
          editData={editData}
        />
      )}
    </>
  );
}
